/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {computeBankingTabSyncValue} from '../api'

export const useMutationComputeBankingTabSyncValue = createReactQueryMutationHook('computeBankingTabSyncValue', computeBankingTabSyncValue)
